import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Reveal } from "../components/motion-primitives";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <div>
      {/* HERO */}
      <section className="bg-section py-20 text-center md:py-24" data-testid="services-hero">
        <div className="container-x">
          <Reveal>
            <span className="eyebrow-pill">What We Offer</span>
            <h1 className="mt-5 font-heading text-4xl font-extrabold tracking-tight md:text-5xl">
              Our Services
            </h1>
            <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-muted-foreground">
              Comprehensive freight forwarding solutions tailored to move your
              cargo — anywhere in the world, on time, every time.
            </p>
          </Reveal>
        </div>
      </section>

      {/* SERVICE SECTIONS */}
      {SERVICES.map((s, i) => (
        <section
          key={s.id}
          id={s.id}
          data-testid={`service-section-${s.id}`}
          className={i % 2 === 1 ? "bg-section" : "bg-white"}
        >
          <div className="container-x grid items-center gap-12 py-16 md:grid-cols-2 md:py-20">
            <Reveal className={i % 2 === 1 ? "md:order-2" : ""}>
              <div className="relative">
                <div className="overflow-hidden rounded-2xl">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="aspect-[16/10] w-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <span
                  data-testid={`service-number-${s.id}`}
                  className="absolute left-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-brand text-sm font-bold text-white shadow-md"
                >
                  {s.num}
                </span>
              </div>
            </Reveal>

            <Reveal delay={0.08} className={i % 2 === 1 ? "md:order-1" : ""}>
              <span className="eyebrow-pill">{s.eyebrow}</span>
              <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight md:text-4xl">
                {s.title}
              </h2>
              <p className="mt-4 leading-relaxed text-muted-foreground">{s.blurb}</p>
              <ul className="mt-7 grid gap-3 sm:grid-cols-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-foreground/80">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                    {p}
                  </li>
                ))}
              </ul>
              <Link to="/contact" data-testid={`service-cta-${s.id}`} className="btn-primary mt-9">
                Get a Quote
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section
        data-testid="services-cta"
        className="bg-gradient-to-r from-[#F5941D] via-[#F9A93B] to-[#FDEBD3]"
      >
        <div className="container-x py-20 text-center md:py-24">
          <Reveal>
            <h2 className="font-heading text-4xl font-extrabold tracking-tight text-white md:text-5xl">
              Ready to Ship?
            </h2>
            <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-white/90">
              Get a customised freight quote from our experts within 2 business
              hours.
            </p>
            <div className="mt-9 flex justify-center">
              <Link to="/contact" data-testid="services-cta-quote" className="btn-white">
                Request a Quote
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
